import { useTableResponsive } from "../../hooks/useTableResponsive";
import { getImplementationDetails } from "../../Utils/utils";
import FilterDistrictsStatesAndBlocks from "./FilterDistrictsStatesAndBlocks";
import DataTable from "datatables.net-dt";
import { useEffect } from "react";

const SwachhVidyalayaTabs = ({ data, title, activeTab }) => {
  // useEffect(() => {
  //   const tableElement = document.getElementById(activeTab);
  //   const table = new DataTable(tableElement, {
  //     info: false,
  //     ordering: true,
  //     paging: true,
  //   });
  //   return () => {
  //     table.destroy();
  //   };
  // }, [data]);

  useEffect(() => {
    const tableElement = document.getElementById(activeTab);
    const table = new DataTable(tableElement, {
      info: false,
      ordering: true,
      paging: true,
    });

    const filterButton = document.getElementById("filterBtn");
    const filterHandler = () => {
      const selectedProfessionValue =
        document.getElementById("filterState").value;
      const selectedCityValue = document.getElementById("filterDistrict").value;
      const selectedAgeValue = document.getElementById("filterBlock").value;
      const selectedValue = `${selectedProfessionValue} ${selectedCityValue} ${selectedAgeValue}`;
      // const selectedValue = `${selectedProfessionValue}`;
      table.search(selectedValue).draw();
    };

    if (filterButton) {
      filterButton.addEventListener("click", filterHandler);
    }

    return () => {
      table.destroy();
      if (filterButton) {
        filterButton.removeEventListener("click", filterHandler);
      }
    };
  }, [activeTab]);

  useTableResponsive(activeTab);

  return (
    <>
      <div className="title-sec wow fadeIn">
        <h2>{data?.title}</h2>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
            <div className="d-flex justify-content-end">
              <ul className="inn_list list_cstar">
                <li>
                  <a href={getImplementationDetails(activeTab)} target="_blank" rel="noopener noreferrer">
                    {title} Report
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {activeTab !== "Survey-Team" &&
          activeTab !== "Completed-Toilet-Report" &&
          activeTab !== "SVA-Summary" && (
            <FilterDistrictsStatesAndBlocks activeTab={activeTab} />
          )}

        <div dangerouslySetInnerHTML={{ __html: data?.body }}></div>
      </div>
    </>
  );
};

export default SwachhVidyalayaTabs;
